// extracted by mini-css-extract-plugin
module.exports = {"number":"100"};
    if(module.hot) {
      // 1747187660675
      var cssReload = require("D:/word/aiks-big-screen-v1-shanxi/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":true});
      module.hot.dispose(cssReload);
      
    }
  